import OmniApiClient from "./base";

export const sheetsApi = {
  // --- Sheet Settings ---
  getAllSettings: () => OmniApiClient.get("/sheets/"),

  getSettingsByServiceAndName: (service, name) =>
    OmniApiClient.get(`/sheets/${service}/${name}`),

  getSettingsById: (id) => OmniApiClient.get(`/sheets/${id}`),

  /** Create or update settings (matched by service + name). */
  saveSettings: (settings) => OmniApiClient.post("/sheets/", settings),

  /** Reset only the column_mapping to {} */
  resetColumnMapping: (id) =>
    OmniApiClient.patch(`/sheets/${id}/reset-mapping`),

  deleteSettings: (id) => OmniApiClient.delete(`/sheets/${id}`),
};
